import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select } from "antd";
import { getRequest } from "services/EndPointApiService";

const { Option } = Select;

const CustomerAddressForm = ({ onFinish, initialValues }) => {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);

  const [selectedProv, setSelectedProv] = useState(initialValues.province);
  const [selectedCity, setSelectedCity] = useState(initialValues.city);
  const [selectedDist, setSelectedDist] = useState(initialValues.district);

  useEffect(() => {
    getRequest("CustomerAdress/Provinsi").then((res) => {
      setProvinces(res);
    });
  }, []);

  const handleProvinceChange = (provinceName) => {
    if (provinceName) {
      setSelectedProv(provinceName);
      setSelectedCity(null);
      setSelectedDist(null);
      setCities([]);
      setDistricts([]);
      setSubDistricts([]);
      getRequest("CustomerAdress/Kabupaten/" + provinceName).then((res) => {
        setCities(res);
      });
    }
  };

  const handleCityChange = (cityName) => {
    if (cityName) {
      setSelectedCity(cityName);
      setSelectedDist(null);
      setDistricts([]);
      setSubDistricts([]);
      getRequest(
        "CustomerAdress/kecamatan/" + selectedProv + "/" + cityName
      ).then((res) => {
        setDistricts(res);
      });
    }
  };

  const handleDistrictChange = (districtName) => {
    if (districtName) {
      setSelectedDist(districtName);
      setSubDistricts([]);
      getRequest(
        "CustomerAdress/kelurahan/" +
          selectedProv +
          "/" +
          selectedCity +
          "/" +
          districtName
      ).then((res) => {
        setSubDistricts(res);
      });
    }
  };

  return (
    <Form
      className="form-custom-input"
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
      style={{ marginTop: "12px" }}
    >
      <Form.Item
        name="recipientName"
        label={<span>Nama Penerima</span>}
        rules={[{ required: true, message: "Masukkan nama penerima" }]}
      >
        <Input placeholder="Masukkan nama penerima" />
      </Form.Item>

      <Form.Item
        name="noHp"
        label={<span>No HP Penerima</span>}
        rules={[{ required: true, message: "Masukkan nomor HP" }]}
      >
        <Input placeholder="Masukkan nomor HP" />
      </Form.Item>

      <Form.Item
        name="recipientAddress"
        label={<span>Alamat Lengkap</span>}
        rules={[{ required: true, message: "Masukkan alamat penerima" }]}
      >
        <Input.TextArea rows={3} placeholder="Masukkan alamat lengkap" />
      </Form.Item>

      <Form.Item
        name="province"
        label={<span>Provinsi</span>}
        rules={[{ required: true, message: "Pilih provinsi" }]}
      >
        <Select
          showSearch
          placeholder="Pilih Provinsi"
          onChange={handleProvinceChange}
        >
          {provinces.map((prov) => (
            <Option key={prov.province} value={prov.province}>
              {prov.province}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="city"
        label={<span>Kota/Kabupaten</span>}
        rules={[{ required: true, message: "Pilih kota/kabupaten" }]}
      >
        <Select
          showSearch
          placeholder="Pilih Kota/Kabupaten"
          onChange={handleCityChange}
          disabled={!selectedProv}
        >
          {cities.map((city) => (
            <Option key={city.city} value={city.city}>
              {city.city}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="district"
        label={<span>Kecamatan</span>}
        rules={[{ required: true, message: "Pilih kecamatan" }]}
      >
        <Select
          showSearch
          placeholder="Pilih Kecamatan"
          onChange={handleDistrictChange}
          disabled={!selectedCity || !selectedProv}
        >
          {districts.map((district) => (
            <Option key={district.district} value={district.district}>
              {district.district}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="subdistrict"
        label={<span>Kelurahan/Desa</span>}
        rules={[{ required: true, message: "Pilih kelurahan/desa" }]}
      >
        <Select
          showSearch
          placeholder="Pilih Kelurahan/Desa"
          disabled={!selectedCity || !selectedProv || !selectedDist}
        >
          {subDistricts.map((subdistrict) => (
            <Option
              key={subdistrict.subdistrict}
              value={subdistrict.subdistrict}
            >
              {subdistrict.subdistrict}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          block
          style={{ marginTop: "24px" }}
        >
          Simpan
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CustomerAddressForm;
